export const formatCurrency = (price, currency = 'GBP') =>
  new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency
  }).format(price)

export default formatCurrency
